/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_SubscriptionInputs */

const en_upgrade_subscription = /** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Subscription`)
};

const es_upgrade_subscription = /** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar Suscripción`)
};

const fr_upgrade_subscription = /** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorer l'abonnement`)
};

const de_upgrade_subscription = /** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement upgraden`)
};

const id_upgrade_subscription = /** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkatkan Langganan`)
};

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const ja_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const zh_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const ar_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const it_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const ru_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const pt_upgrade_subscription = en_upgrade_subscription;

/** @type {(inputs: Upgrade_SubscriptionInputs) => LocalizedString} */
const ko_upgrade_subscription = en_upgrade_subscription;

/**
* | output |
* | --- |
* | "Upgrade Subscription" |
*
* @param {Upgrade_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_subscription = /** @type {((inputs?: Upgrade_SubscriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_SubscriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_subscription(inputs)
	if (locale === "es") return es_upgrade_subscription(inputs)
	if (locale === "fr") return fr_upgrade_subscription(inputs)
	if (locale === "de") return de_upgrade_subscription(inputs)
	if (locale === "ja") return ja_upgrade_subscription(inputs)
	if (locale === "zh") return zh_upgrade_subscription(inputs)
	if (locale === "ar") return ar_upgrade_subscription(inputs)
	if (locale === "id") return id_upgrade_subscription(inputs)
	if (locale === "it") return it_upgrade_subscription(inputs)
	if (locale === "ru") return ru_upgrade_subscription(inputs)
	if (locale === "pt") return pt_upgrade_subscription(inputs)
	return ko_upgrade_subscription(inputs)
});